var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 104 92",
    viewBox: "0 0 104 92",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m90 46.4c0 20.3-16.7 36.8-37.2 36.8-20.6 0-37.2-16.5-37.2-36.8s16.7-36.8 37.2-36.8 37.2 16.5 37.2 36.8z",
    fill: "#bf908f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m38.3 52.1c0-8.5 6.9-15.4 15.3-15.4s15.4 6.9 15.4 15.4-6.9 15.3-15.3 15.3c-8.5 0-15.4-6.9-15.4-15.3zm3.4 0c0 6.6 5.4 12 12 12s12-5.4 12-12-5.4-12-12-12-12 5.4-12 12z",
    fill: "#f5cf93"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m59.3 26.2-1.7 3.2h-7.8l-1.7-3.2z",
    fill: "#dbf0f0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m47.5 26.4 1.5 2.9h-3.6z",
    fill: "#bae3e3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m57.2 30.1-3.5 6.5-3.5-6.5z",
    fill: "#bae3e3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m53 36.8-7.6-6.7h4z",
    fill: "#60b3b3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m57.9 30.1h4l-7.5 6.7z",
    fill: "#60b3b3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m59.8 26.5 2.1 2.9h-3.6z",
    fill: "#bae3e3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m50.6 34.8h6.2v2.4h-6.2z",
    fill: "#bc9935"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRing);
export default __webpack_public_path__ + "static/media/ring.ee366e89182d01460d89249460811168.svg";
export { ForwardRef as ReactComponent };